module.exports = __webpack_public_path__ + "img/17.cc65c4c8.png";